import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Transition as _Transition, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73a4f6f3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tabs-row" }
const _hoisted_2 = { class: "tabs" }
const _hoisted_3 = { class: "tabs-container" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "dropdown" }
const _hoisted_6 = {
  class: "filter-btn",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_7 = { class: "scroll-container" }
const _hoisted_8 = {
  class: "dropdown-menu dropdown-menu-lg-end",
  "aria-labelledby": "dropdownMenuButton1"
}
const _hoisted_9 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseIcon = _resolveComponent("BaseIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.brandtabs, (tab, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: tab.id,
            class: _normalizeClass(_ctx.isActiveBrandTab(tab) ? 'active' : ''),
            onClick: ($event: any) => (_ctx.handleBrandTabChange(index))
          }, _toDisplayString(tab.name), 11, _hoisted_4))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          _createElementVNode("button", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", null, _toDisplayString(_ctx.selectedchannel.fullname), 1),
              _createVNode(_component_BaseIcon, {
                name: "chevron-down",
                size: "8px"
              })
            ])
          ])
        ]),
        _: 1
      }),
      _createElementVNode("ul", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allowedChannelTabs, (channel) => {
          return (_openBlock(), _createElementBlock("li", {
            key: channel.code
          }, [
            _createElementVNode("a", {
              class: "dropdown-item",
              onClick: ($event: any) => (_ctx.changeChannel(channel))
            }, _toDisplayString(channel.fullname), 9, _hoisted_9)
          ]))
        }), 128))
      ])
    ])
  ]))
}